import { render, staticRenderFns } from "./ViewNotification.vue?vue&type=template&id=b95a3818"
import script from "./ViewNotification.vue?vue&type=script&lang=js"
export * from "./ViewNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports